<template>
  <el-row>
    <div class="wrap">
      <h1 align="center">{{ detailData.fileName }}</h1>
      <div class="readFinish" v-if="detailData.flag != 'blank'">
        <span style="position: absolute;left:10px">
          <!-- 打印页数：
          <el-input v-model="pageInfo" placeholder="例：1-2,5,8,10-15" style="width:150px" size="small" @change="pageInfoBlur" :disabled="inputDisabled"></el-input> -->
          <!-- <p v-if="checkPageInfo">{{checkPageInfoMessage}}</p> -->
          签章位置：
          <el-radio-group v-model="location" :disabled="disLocation">
            <el-radio label="0">左上</el-radio>
            <el-radio label="2">右上</el-radio>
            <el-radio label="4">右下</el-radio>
          </el-radio-group>
        </span>
        <el-button size="small" type="primary" icon="el-icon-circle-close" @click="getParam()" v-if="btnCancel">取消签章</el-button>
        <el-button size="small" type="primary" icon="el-icon-brush" @click="loadPDFWithSign()" v-if="loadPDFSign">签章</el-button>
        <!-- <el-button :disabled="isPrint" size="small" type="primary" icon="el-icon-printer" @click="doPrint()">打印</el-button> -->
        <el-button size="small" type="primary" icon="el-icon-brush" @click="savePDF()" v-if="btnCancel">保存</el-button>
        <el-button :disabled="download" size="mini" type="primary" @click="fileDownload()" icon="el-icon-download">下载</el-button>
      </div>
      <div style="clear:both"></div>
      <div class="fileContent" id="printContent">
        <iframe :src="pSrc" width="100%" height="95%" id="myIframe"> </iframe>
      </div>
    </div>
  </el-row>
</template>
 
<script>
let _self;
import api from "@/api";
export default {
  // 引进子组件
  props: ["transData","fatherMethod"],
          
  data() {
    return {
      //pdf预览插件路径
      //本地
      pdfViewPath : "/static/pdf/web/viewer.html",
      fileServerURL : "https://ymjdoa.top/uploadprod/upload/file/1/1",
      fileDownloadApi: "https://ymjdoa.top/uploadprod/upload/",
      inputDisabled: false,
      // checkPageInfoMessage: "",
      checkPageInfo: false,
      pageInfo: "",
      // 下载按钮是否显示
      download: false,
      disLocation: false,
      // 签章按钮是否显示
      loadPDFSign: false,
      // 取消按钮
      btnCancel: false,
      // 签章位置是否禁用
      // disLocation:false,
      // 签章位置
      location: "0",
      newLocation: "",
      userData: "",
      searchUserVisible: false,
      pSrc: "",
      fileId: "",
      printObj: {
        id: "printContent",
        popTitle: "档案详情",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      saveFlag: 0,
      isPrint: true,
      detailData: {
        filePath: '',
        fileName: '',
        flag: '',
        archivesId: '',
        daId: '',
        tableName: '',
      },
      fileUrl: "",
      sealPic: ""
    };
  },
  created: function () {
    _self = this;
    let queryData = _self.$route.query.query;
    if (!_self.transData) {
      let decodeRes = JSON.parse(Base64.decode(queryData));
      _self.detailData = { fileName: '' }
      _self.detailData.filePath = decodeRes.fileResourceCode;
      _self.detailData.fileName = decodeRes.fileName;
      _self.detailData.flag = decodeRes.flag;
      _self.detailData.archivesId = decodeRes.archivesId;
      _self.detailData.daId = decodeRes.id;
      _self.detailData.tableName = decodeRes.tableName;
      _self.detailData.ajType = "";
      _self.fileUrl = decodeRes.fileUrl;
      _self.sealPic = decodeRes.sealPic;
    } else {
      _self.detailData = _self.transData;
    }
    // console.log("url:",decodeRes.fileUrl)
    console.log("url:",_self.transData.fileUrl)
    _self.getParam();
  },
  mounted() {
    // _self.getParam();
  },
  methods: {
    // input输入框校验
    pageInfoBlur(val) {
      var pageNums = myIframe.contentWindow.document.getElementById("numPages").innerText.substring(2);
      if (_self.pageInfo) {
        if (!(RegExp(/^[0-9\,\-\，]+$/).test(val))){
          _self.checkPageInfo = true;
          // _self.checkPageInfoMessage = "输入的打印页数格式有误，请重新输入！"
          return _self.$message({
            message: "输入的打印页数格式有误，请重新输入！",
            type: "error"
          });
        } else {
          // debugger;
          let numbers = val.replace(RegExp(/[，|,]/g), ' ').trim().split(' ');
          for (let index in numbers) {
            if (numbers[index].indexOf('-') >= 0) {
              let nums = numbers[index].split('-');
              if (parseInt(nums[0])  > parseInt(nums[1]) || !nums[0] || !nums[1]) {
                _self.checkPageInfo = true;
                // return _self.checkPageInfoMessage = "输入的打印页数范围有误，请重新输入！"
                return _self.$message({
                  message: "输入的打印页数范围有误，请重新输入！",
                  type: "error"
                });
              }
            }
          }
          numbers = val.replace(RegExp(/[-|，|,]/g), ' ').trim().split(' ');
          for (let index in numbers) {
            if (!numbers[index] || parseInt(numbers[index]) > parseInt(pageNums)) {
              _self.checkPageInfo = true;
              // return _self.checkPageInfoMessage = "输入的打印页数超出文件总页数，请重新输入！"
              return _self.$message({
                message: "输入的打印页数超出文件总页数，请重新输入！",
                type: "error"
              });
            }
          }
          _self.checkPageInfo = false;
        }
      } else {
        _self.pageInfo = "";
        _self.checkPageInfo = false;
      }
    },
    // 取到路由带过来的参数
    getParam() {
      _self.download = true;
      _self.disLocation = false;
      _self.inputDisabled = false;
      _self.loadPDFSign = true;
      _self.btnCancel = false;
      _self.isPrint = true;
      //baseurl ：pdf存放的文件路径，可以是本地的，也可以是远程，这个是远程的，亲测可以用"3VFXAVAo5JHWZJoYUPSZ523MBA"
      let baseurl = _self.fileDownloadApi + _self.transData.fileUrl;
      this.pSrc =
        _self.pdfViewPath  + "?file=" + encodeURIComponent(baseurl);
    },

    //添加签章预览
    loadPDFWithSign() {
      if (!_self.checkPageInfo) {
        _self.download = false;
        _self.disLocation = true;
        _self.inputDisabled = true;
        _self.isPrint = false;
        _self.loadPDFSign = false;
        _self.btnCancel = true;
        var saveFlag = 0;
        _self.newLocation = _self.location;
        let baseurl = _self.fileDownloadApi + _self.transData.fileUrl + "/attachment/" + _self.transData.sealPic
                       + "?save=" + saveFlag + "&location=" + _self.location;
        this.pSrc =
          _self.pdfViewPath + "?file=" + encodeURIComponent(baseurl);
      }

      // _self.disLocation = true
    },
    savePDF() {
      this.fatherMethod();
      if (!_self.checkPageInfo) {
        _self.download = false;
        _self.disLocation = true;
        _self.inputDisabled = true;
        _self.isPrint = false;
        _self.loadPDFSign = false;
        _self.btnCancel = true;
        var saveFlag = 1;
        let baseurl = _self.fileDownloadApi + _self.transData.fileUrl + "/attachment/" + _self.transData.sealPic
                      + "?save=" + saveFlag + "&location=" + _self.newLocation;
        console.log(baseurl);
        window.location.href =baseurl;
        // this.pSrc =
        //   _self.pdfViewPath + "?file=" + encodeURIComponent(baseurl);
        // 将申请表状态改为'5'
        console.log("fireUrl:",_self.transData.fileUrl)
        api.pdfDetailAPI.modifyInfo({fileUrl: _self.transData.fileUrl}).then(res => {
          if (res.status = 200) {
            this.$message({
              message: '保存成功',
              type: 'success'
            });
          }
        });
      }
      // _self.disLocation = true
    },

    // 打印调用
    doPrint() {
      var myIframe = document.getElementById("myIframe");
      //通过获取到的window对象操作HTML元素，这和普通页面一样
      var p = myIframe.contentWindow.document.getElementById("print");
      //添加记录
      _self.detailData.type = 3;
      CSearchLog.insertLog(_self.detailData);
      // p.click();
      myIframe.contentWindow.print();
    },

    // 下载
    fileDownload() {
      if (!_self.checkPageInfo) {
          window.location.href = _self.fileDownloadApi + _self.transData.fileUrl;
      }
    },
  },
};
</script>
 
<style scoped>
.wrap {
  width: 100%;
  position: relative;
}

.wrap p {
  color: #f56c6c;
  position: absolute;
  left: 80px;
}

.readFinish {
  background-color: rgb(221, 218, 218);
  text-align: right;
  margin-top: 20px;
}

.fileContent {
  height: 100vh;
}
</style>